import React, { useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { renderTextField } from "../formcomponents";
import { Grid, Divider, Button } from "semantic-ui-react";
import axios from "axios";
import Swal from "sweetalert2";
import { BaseUrl, BaseImgUploadUrl } from "../formcomponents/Constants";

const validate = (values) => {
  const errors = {};
  if (!values.userFirstName) {
    errors.userFirstName = "Required";
  }
  if (!values.contactNum) {
    errors.contactNum = "Required";
  }
  if (!values.userEmail) {
    errors.userEmail = "Required";
  }
  if (!values.userLastName) {
    errors.userLastName = "Required";
  }
  if (!values.nationality) {
    errors.nationality = "Required";
  }
  return errors;
};

const UserProfile = (props) => {
  const { handleSubmit, pristine, reset, submitting, userId } = props;
  useEffect(() => {
    // console.log("userId", userId);
    getUserDetails();
  }, []);

  const [userDetails, setuserDetails] = useState({});

  const [fileStorage, setfileStorage] = useState([]);
  const [imageArr, setimageArr] = useState([]);
  const getUserDetails = async () => {
    await axios
      .post(BaseUrl + "getUserDetails", { userEmail: userId })
      .then((res) => {
        // console.log(res.data);
        initializeData(res.data);
        setuserDetails(res.data);
        let values = [...fileStorage];

        values.push(
          {
            fileStorageId: res.data.passportFileId,
            // key: "passportFileId",
          },
          {
            fileStorageId: res.data.visaFileId,
            // key: "visaFileId",
          },
          {
            fileStorageId: res.data.idProofFileId,
            // key: "idProofFileId",
          }
        );
        setfileStorage(values);

        getAllImageFiles(values);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const initializeData = (tempData) => {
    props.initialize({
      userId: tempData.userId,
      userEmail: tempData.userEmail,
      userPassword: tempData.userPassword,
      userFirstName: tempData.userFirstName,
      userLastName: tempData.userLastName,
      userDob: tempData.userDob,
      userOtp: tempData.userOtp,
      contactNum: tempData.contactNum,
      nationality: tempData.nationality,
      alternateContact: tempData.alternateContact,
      readyForCollection: tempData.readyForCollection,
      passportFileId: tempData.passportFileId,
      passportExpiry: tempData.passportExpiry,
      passportNote: tempData.passportNote,
      visaFileId: tempData.visaFileId,
      visaExpiry: tempData.visaExpiry,
      visaNote: tempData.visaNote,
      idProofFileId: tempData.idProofFileId,
      idProofExpiry: tempData.idProofExpiry,
      idProofNote: tempData.idProofNote,
    });
  };
  const getAllImageFiles = async (fileids) => {
    await axios
      .post(BaseUrl + "getFileDetailList", fileids)
      .then((res) => {
        // console.log(res.data);
        setimageArr(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const passportImage = imageArr.find(
    (img) => img.fileStorageId === userDetails.passportFileId
  );
  const visaFileId = imageArr.find(
    (img) => img.fileStorageId === userDetails.visaFileId
  );
  const idProofFileId = imageArr.find(
    (img) => img.fileStorageId === userDetails.idProofFileId
  );

  const sumbitForm = (values) => {
    console.log(values);
    axios
      .post(BaseUrl + "setUserDetails", values)
      .then((res) => {
        if (res.data.errCode === 200) {
          Swal.fire("User Details Updated");
        }
      })
      .catch((error) => {});
  };
  // const imageUrl = BaseImgUploadUrl + passportImage.fileName;

  const handleDownload = (fileUrl, fileName) => {
    axios
      .get(fileUrl, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading PDF:", error);
      });
  };
  return (
    <div>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column></Grid.Column>
          <Grid.Column>
            <Field
              name="userFirstName"
              label="First Name"
              type="text"
              component={renderTextField}
            />
            <Field
              name="contactNum"
              label="Contact Number"
              type="text"
              component={renderTextField}
            />
            <Field
              name="userEmail"
              label="Email"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="userLastName"
              label="Last Name"
              type="text"
              component={renderTextField}
            />
            <Field
              name="alternateContact"
              label="AlterNative Contact"
              type="text"
              component={renderTextField}
            />
            <Field
              name="nationality"
              label="Nationality"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>

        <Divider section />
        <Grid.Row>
          <Grid.Column>
            {passportImage && (
              <img
                src={`https://parmartours.com:8443/filestorage/silverstar/images/${passportImage.fileName}`}
                height="150px"
                width="150px"
              />
            )}
            {/* <Button
              onClick={() =>
                handleDownload(
                  `https://travelpack365.com:8443/filestorage/silverstar/images/${passportImage.fileName}`,
                  "test"
                )
              }
            >
              save
            </Button> */}
          </Grid.Column>
          <Grid.Column>
            <h3
              style={{
                marginBottom: "40px",
              }}
            >
              Passport Information
            </h3>
            {/* <Field
              name="passportFileId"
              label="Upload Passport"
              type="text"
              component={renderTextField}
            /> */}
          </Grid.Column>
          <Grid.Column>
            <Field
              name="passportExpiry"
              label="Passport Expiry"
              type="date"
              component={renderTextField}
            />
            <Field
              name="passportNote"
              label=" Note"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column>
            {visaFileId && (
              <img
                src={`https://parmartours.com:8443/filestorage/silverstar/images/${visaFileId.fileName}`}
                height="150px"
                width="150px"
              />
            )}
          </Grid.Column>
          <Grid.Column>
            <h3
              style={{
                marginBottom: "40px",
              }}
            >
              Visa Information
            </h3>
            {/* <Field
              name="visaFileId"
              label="Upload Image"
              type="text"
              component={renderTextField}
            /> */}
          </Grid.Column>
          <Grid.Column>
            <Field
              name="visaExpiry"
              label="Expiry"
              type="date"
              component={renderTextField}
            />
            <Field
              name="visaNote"
              label="Note"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            {idProofFileId && (
              <img
                src={`https://parmartours.com:8443/filestorage/silverstar/images/${idProofFileId.fileName}`}
                height="150px"
                width="150px"
              />
            )}
          </Grid.Column>
          <Grid.Column>
            <h3
              style={{
                marginBottom: "40px",
              }}
            >
              ID Information
            </h3>
            {/* <Field
              name="idProofFileId"
              label="Upload Image"
              type="text"
              component={renderTextField}
            /> */}
          </Grid.Column>
          <Grid.Column>
            <Field
              name="idProofExpiry"
              label="Expiry"
              type="date"
              component={renderTextField}
            />
            <Field
              name="idProofNote"
              label="Note"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Button
        type="submit"
        floated="right"
        positive
        disabled={submitting}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save user
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>
    </div>
  );
};

export default reduxForm({
  form: "UserProfile",
  // validate,
})(UserProfile);
